module.exports = __webpack_public_path__ + "static/img/dynamicw.217f011.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicw.png
// module id = zpMR
// module chunks = 45